var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M27.16 12c-4.331 0-7.842 3.504-7.842 7.826 0 1.15.248 2.241.694 3.224L12 31.104V35a1 1 0 001 1h3.277a1 1 0 001-1v-1.933h2.35a1 1 0 001-1v-2.408l3.056-2.816a7.82 7.82 0 003.476.81c4.33 0 7.841-3.505 7.841-7.827S31.49 12 27.16 12zm1.567 3.757c1.155 0 2.091.934 2.091 2.086a2.089 2.089 0 01-2.09 2.087 2.089 2.089 0 01-2.092-2.087c0-1.152.936-2.086 2.091-2.086z", fill: "currentColor", fillRule: "nonzero", stroke: "none", strokeWidth: 1 })));
});
